import { Directive, ElementRef, Input, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';

import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { unsubscribe } from '@fcom/core/utils';

@Directive({
  selector: '[finFocus]',
})
export class FocusDirective implements OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('finFocus')
  set finFocus(focusObservable$: Observable<boolean>) {
    if (isPlatformServer(this.platform)) {
      return;
    }
    if (!focusObservable$) {
      this.unsubscribe();
      return;
    }
    this.subscription = focusObservable$.pipe(filter((shouldFocus) => shouldFocus)).subscribe(() => {
      if (this.elementRef.nativeElement) {
        this.elementRef.nativeElement.focus();
      }
    });
  }
  private subscription: Subscription;

  constructor(
    private elementRef: ElementRef,
    @Inject(PLATFORM_ID) private platform: object
  ) {}

  ngOnDestroy(): void {
    this.unsubscribe();
  }

  private unsubscribe() {
    this.subscription = unsubscribe(this.subscription);
  }
}
